import React from 'react'
import { Durations } from '@/constants/durations'
import { useHlsPlayerUI } from './HlsPlayerUIContext'

/**
 * Displays the current playback time and total duration in MM:SS or H:MM:SS format.
 */
export const HlsTimeDisplay: React.FC = () => {
  const { currentTime, duration } = useHlsPlayerUI()

  return (
    <span className="photon-caption-md ml-1 select-none whitespace-nowrap text-white/80">
      {formatTime(currentTime)}
      <span className="mx-0.5 text-white/50">/</span>
      {formatTime(duration)}
    </span>
  )
}

/**
 * Formats seconds into MM:SS or H:MM:SS if the duration exceeds one hour.
 */
function formatTime(seconds: number): string {
  if (!Number.isFinite(seconds) || seconds < 0) return '0:00'

  const totalSeconds = Math.floor(seconds)
  const hours = Math.floor(totalSeconds / Durations.ONE_HOUR_IN_SECONDS)
  const minutes = Math.floor((totalSeconds % Durations.ONE_HOUR_IN_SECONDS) / Durations.ONE_MINUTE_IN_SECONDS)
  const secs = totalSeconds % Durations.ONE_MINUTE_IN_SECONDS
  const paddedSecs = String(secs).padStart(2, '0')

  if (hours > 0) {
    const paddedMins = String(minutes).padStart(2, '0')
    return `${hours}:${paddedMins}:${paddedSecs}`
  }

  return `${minutes}:${paddedSecs}`
}
